export const TimerResendActivation = {
     RESEND_TIMER : 60,
     EXPIRED_TIMER: 5 * 60
}